export default "__VITE_ASSET__CQqX0FYW__"